export default __webpack_public_path__ + "media/flowserve_photo.78205daf.jpg";